import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Clock, Gem } from 'lucide-react';
interface TimeOutModalProps {
  isOpen: boolean;
  onBuyTime: () => void;
  onAcceptLoss: () => void;
  canBuyFree: boolean;
  playerName: string;
}
export function TimeOutModal({
  isOpen,
  onBuyTime,
  onAcceptLoss,
  canBuyFree,
  playerName
}: TimeOutModalProps) {
  return <Modal isOpen={isOpen} onClose={() => {}} title="Time's Up!" className="max-w-md" data-id="element-159">
      <div className="space-y-6" data-id="element-160">
        {/* Warning Message */}
        <div className="text-center py-4" data-id="element-161">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-162">
            <Clock className="text-red-600" size={40} data-id="element-163" />
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-164">
            {playerName} ran out of time!
          </h3>
          <p className="text-slate-600" data-id="element-165">
            Buy more time to continue playing, or accept the loss.
          </p>
        </div>

        {/* Buy Time Options */}
        <div className="space-y-3" data-id="element-166">
          {canBuyFree ? <div className="p-4 bg-emerald-50 border-2 border-emerald-200 rounded-xl" data-id="element-167">
              <div className="flex items-center justify-between mb-2" data-id="element-168">
                <div className="flex items-center gap-2" data-id="element-169">
                  <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center" data-id="element-170">
                    <span className="text-white font-bold text-sm" data-id="element-171">1</span>
                  </div>
                  <span className="font-bold text-emerald-900" data-id="element-172">
                    Free Time Extension
                  </span>
                </div>
                <span className="text-emerald-700 font-semibold" data-id="element-173">FREE</span>
              </div>
              <p className="text-xs text-emerald-700" data-id="element-174">
                Get +30 seconds free (1 per day)
              </p>
            </div> : <div className="p-4 bg-blue-50 border-2 border-blue-200 rounded-xl" data-id="element-175">
              <div className="flex items-center justify-between mb-2" data-id="element-176">
                <div className="flex items-center gap-2" data-id="element-177">
                  <Gem className="text-blue-600" size={20} data-id="element-178" />
                  <span className="font-bold text-blue-900" data-id="element-179">Buy More Time</span>
                </div>
                <span className="text-blue-700 font-semibold" data-id="element-180">💎 50</span>
              </div>
              <p className="text-xs text-blue-700" data-id="element-181">
                Get +30 seconds for 50 diamonds
              </p>
            </div>}

          <Button fullWidth size="xl" onClick={onBuyTime} className="gap-2" data-id="element-182">
            {canBuyFree ? <>
                <Clock size={20} data-id="element-183" />
                Use Free Extension
              </> : <>
                <Gem size={20} data-id="element-184" />
                Buy Time (💎 50)
              </>}
          </Button>

          <Button fullWidth size="lg" variant="outline" onClick={onAcceptLoss} data-id="element-185">
            Accept Loss
          </Button>
        </div>

        {!canBuyFree && <p className="text-xs text-center text-slate-500" data-id="element-186">
            Your free daily extension has been used
          </p>}
      </div>
    </Modal>;
}